import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <h6>
        Copyright © 2024 Australian Qualifications & Training Overseas. All
        Rights Reserved.
      </h6>
    </div>
  );
};

export default Footer;
